import React, { useEffect, createElement } from 'react';
import { Button } from '../components/ui/Button';
import { Accordion } from '../components/ui/Accordion';
import { Footer } from '../components/Footer';
import { useScrollReveal } from '../hooks/useScrollReveal';
import { AlertCircleIcon, XCircleIcon, CheckCircle2Icon, ShieldIcon, ShieldCheckIcon, FileTextIcon, ClockIcon, MessageSquareIcon, LockIcon, CheckIcon } from 'lucide-react';
// Declare fbq function for TypeScript
declare global {
  interface Window {
    fbq: any;
  }
}
// A wrapper component to apply the scroll reveal effect to sections
function RevealSection({
  children,
  className = '',
  id
}: {
  children: React.ReactNode;
  className?: string;
  id?: string;
}) {
  const ref = useScrollReveal();
  return <section id={id} ref={ref} className={`opacity-0 translate-y-8 transition-all duration-700 ease-out ${className}`} data-id="element-113">
      {children}
    </section>;
}
export function LandingPage() {
  useEffect(() => {
    // Initialize Meta Pixel
    ;
    (function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = true;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js', undefined, undefined, undefined);
    window.fbq('init', '1847425635830345');
    window.fbq('track', 'PageView');
  }, []);
  const handleAddToCart = () => {
    // Fire AddToCart event
    if (window.fbq) {
      window.fbq('track', 'AddToCart', {
        content_name: 'Guía Eliminar Deudas Antiguas',
        content_ids: ['52483978461473'],
        content_type: 'product',
        value: 6.39,
        currency: 'USD'
      });
    }
    // Redirect to Shopify
    window.location.href = 'https://guiasparavivir.com/cart/52483978461473:1';
  };
  return <main className="min-h-screen bg-gray-50 font-sans text-gray-900 selection:bg-emerald-200 selection:text-emerald-900" data-id="element-114">
      {/* HERO SECTION */}
      <section className="bg-blue-900 text-white pt-20 pb-24 px-4 relative overflow-hidden" data-id="element-115">
        <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGNpcmNsZSBjeD0iMiIgY3k9IjIiIHI9IjIiIGZpbGw9IiNmZmZmZmYiIGZpbGwtb3BhY2l0eT0iMC4wNSIvPjwvc3ZnPg==')] opacity-30" data-id="element-116"></div>
        <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-117">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-blue-800/50 border border-blue-700 text-blue-100 text-sm font-semibold mb-8 tracking-wide uppercase" data-id="element-118">
            <ShieldIcon className="w-4 h-4" data-id="element-119" />
            <span data-id="element-120">Protección Legal Federal</span>
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold leading-tight mb-6 tracking-tight" data-id="element-121">
            Eliminar Deudas Antiguas en 48 Horas{' '}
            <span className="text-emerald-400" data-id="element-122">Sin Pagar un Solo Centavo</span>{' '}
            a los Cobradores
          </h1>

          <h2 className="text-xl md:text-2xl text-blue-100 font-medium leading-relaxed mb-12 max-w-3xl mx-auto" data-id="element-123">
            El método legal paso a paso para detener el acoso telefónico, anular
            cobros que ya caducaron y recuperar tu paz mental hoy mismo.
          </h2>

          <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-2xl p-6 md:p-8 text-left mb-10 shadow-2xl" data-id="element-124">
            <p className="text-lg md:text-xl leading-relaxed text-white" data-id="element-125">
              <strong className="text-emerald-300 font-bold" data-id="element-126">
                Son las 8:00 de la noche.
              </strong>{' '}
              Estás intentando cenar tranquila cuando tu teléfono vibra. Un
              número desconocido. Al contestar, una voz agresiva te amenaza con
              demandas y embargos por una deuda que ya habías olvidado hace 10
              años. Ese frío que sientes en el estómago no es miedo, es la señal
              de que están intentando intimidarte con una "Deuda Zombi".
            </p>
            <p className="text-lg md:text-xl leading-relaxed text-white mt-4" data-id="element-127">
              La mayoría de las personas entran en pánico y comete el error más
              grave: prometer un pago pequeño. No saben que, al hacerlo, acaban
              de "resucitar" legalmente una deuda que ya estaba muerta.
            </p>
          </div>

          <Button onClick={() => document.getElementById('offer')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-128">
            ELIMINAR MIS DEUDAS AHORA
          </Button>
          <div className="flex items-center justify-center gap-4 mt-6 text-blue-200 text-sm font-medium" data-id="element-129">
            <span className="flex items-center gap-1" data-id="element-130">
              <LockIcon className="w-4 h-4" data-id="element-131" /> Pago Seguro
            </span>
            <span className="flex items-center gap-1" data-id="element-132">
              <CheckCircle2Icon className="w-4 h-4" data-id="element-133" /> Acceso Instantáneo
            </span>
          </div>
        </div>
      </section>

      {/* THE PROBLEM */}
      <RevealSection className="py-20 px-4 bg-white" data-id="element-134">
        <div className="max-w-4xl mx-auto" data-id="element-135">
          <div className="flex items-center gap-4 mb-8" data-id="element-136">
            <div className="w-12 h-12 rounded-full bg-red-100 flex items-center justify-center flex-shrink-0" data-id="element-137">
              <AlertCircleIcon className="w-6 h-6 text-red-600" data-id="element-138" />
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900" data-id="element-139">
              El negocio sucio de las agencias de cobranza
            </h2>
          </div>

          <div className="prose prose-lg max-w-none text-gray-700" data-id="element-140">
            <p className="text-xl leading-relaxed mb-6" data-id="element-141">
              Las agencias de cobranza compran paquetes de deudas viejas por
              centavos. Saben perfectamente que muchas de esas deudas ya
              prescribieron legalmente y que no pueden llevarte a juicio.{' '}
              <strong data-id="element-142">Su única estrategia es el terror sicológico.</strong>
            </p>
            <p className="text-xl leading-relaxed mb-8" data-id="element-143">
              Te llaman al trabajo, acosan a tus familiares y te hacen creer que
              vas a ir a la cárcel o que perderás tu casa. Juegan con tu falta
              de conocimiento legal para obligarte a pagar algo que, por ley, ya
              no tienes obligación de pagar. Cada noche que pasas sin actuar,
              ellos ganan terreno.
            </p>
          </div>
        </div>
      </RevealSection>

      {/* WHY WHAT YOU TRIED DIDN'T WORK */}
      <RevealSection className="py-20 px-4 bg-gray-50 border-y border-gray-200" data-id="element-144">
        <div className="max-w-4xl mx-auto" data-id="element-145">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-10 text-center" data-id="element-146">
            Por qué lo que has intentado no funciona
          </h2>

          <div className="space-y-4" data-id="element-147">
            {['Intentaste ignorar las llamadas, pero solo consigues que llamen con más frecuencia y a horas prohibidas.', 'Intentaste razonar con el cobrador, pero ellos están entrenados para ignorar tus explicaciones y seguir presionando.', 'Buscaste información en internet, pero terminaste más confundida con términos legales que no se aplican a tu estado.', 'Pensaste en contratar un abogado, pero el costo de la consulta es más caro que la deuda misma.', 'Les prometiste un pago pequeño para que te dejaran en paz, y lo único que lograste fue reiniciar el reloj legal de la deuda.'].map((item, index) => <div key={index} className="flex items-start gap-4 bg-white p-6 rounded-xl shadow-sm border border-gray-100" data-id="element-148">
                <XCircleIcon className="w-7 h-7 text-red-500 flex-shrink-0 mt-0.5" data-id="element-149" />
                <p className="text-lg text-gray-800 font-medium" data-id="element-150">{item}</p>
              </div>)}
          </div>
        </div>
      </RevealSection>

      {/* THE UNIQUE MECHANISM */}
      <RevealSection className="py-24 px-4 bg-blue-900 text-white relative" data-id="element-151">
        <div className="max-w-4xl mx-auto text-center" data-id="element-152">
          <h2 className="text-3xl md:text-4xl font-bold mb-8" data-id="element-153">
            Presentamos el sistema <br className="hidden md:block" data-id="element-154" />
            <span className="text-emerald-400" data-id="element-155">
              "Reloj Legal y Escudo Antiacoso"
            </span>
          </h2>
          <p className="text-xl leading-relaxed text-blue-100 mb-8 max-w-3xl mx-auto" data-id="element-156">
            Este método no se basa en trucos, sino en el uso estricto de la Ley
            Federal de Prácticas Justas en el Cobro de Deudas (FDCPA).
          </p>
          <p className="text-xl leading-relaxed text-blue-100 max-w-3xl mx-auto" data-id="element-157">
            Aprenderás a identificar el momento exacto en que una deuda "muere"
            legalmente en tu estado y cómo emitir una Notificación de Cese y
            Desistimiento que obliga a los cobradores a desaparecer de tu vida
            en menos de 48 horas. Una vez que activas el Escudo, ellos saben que
            ya no tienen poder sobre ti.
          </p>
        </div>
      </RevealSection>

      {/* WHAT YOU GET */}
      <RevealSection className="py-20 px-4 bg-white" data-id="element-158">
        <div className="max-w-5xl mx-auto" data-id="element-159">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-12 text-center" data-id="element-160">
            Lo que obtienes hoy mismo
          </h2>

          <div className="grid md:grid-cols-2 gap-8" data-id="element-161">
            <div className="bg-gray-50 p-8 rounded-2xl border border-gray-200 flex flex-col items-start" data-id="element-162">
              <div className="w-14 h-14 bg-blue-100 text-blue-700 rounded-xl flex items-center justify-center mb-6" data-id="element-163">
                <FileTextIcon className="w-7 h-7" data-id="element-164" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3" data-id="element-165">
                Guía Digital "Elimina Deudas Antiguas en 48 Horas"
              </h3>
              <p className="text-lg text-gray-700" data-id="element-166">
                El manual paso a paso con la estrategia completa explicada de
                forma sencilla y directa.
              </p>
            </div>

            <div className="bg-gray-50 p-8 rounded-2xl border border-gray-200 flex flex-col items-start" data-id="element-167">
              <div className="w-14 h-14 bg-emerald-100 text-emerald-700 rounded-xl flex items-center justify-center mb-6" data-id="element-168">
                <ClockIcon className="w-7 h-7" data-id="element-169" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3" data-id="element-170">
                El Reloj Legal
              </h3>
              <p className="text-lg text-gray-700" data-id="element-171">
                Tabla de prescripción por estado para que sepas exactamente
                cuándo caduca cada tipo de deuda.
              </p>
            </div>

            <div className="bg-gray-50 p-8 rounded-2xl border border-gray-200 flex flex-col items-start" data-id="element-172">
              <div className="w-14 h-14 bg-purple-100 text-purple-700 rounded-xl flex items-center justify-center mb-6" data-id="element-173">
                <CheckCircle2Icon className="w-7 h-7" data-id="element-174" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3" data-id="element-175">
                Hoja de Diagnóstico
              </h3>
              <p className="text-lg text-gray-700" data-id="element-176">
                Para determinar en 5 minutos si tu deuda es "Zombi" y legalmente
                nula.
              </p>
            </div>

            <div className="bg-gray-50 p-8 rounded-2xl border border-gray-200 flex flex-col items-start" data-id="element-177">
              <div className="w-14 h-14 bg-orange-100 text-orange-700 rounded-xl flex items-center justify-center mb-6" data-id="element-178">
                <MessageSquareIcon className="w-7 h-7" data-id="element-179" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3" data-id="element-180">
                Modelo de Carta y Guion
              </h3>
              <p className="text-lg text-gray-700" data-id="element-181">
                Solo copia, pega tus datos y envíala por correo certificado.
                Incluye las palabras exactas que debes decir si vuelven a
                llamarte.
              </p>
            </div>
          </div>

          <div className="mt-12 text-center" data-id="element-182">
            <Button onClick={() => document.getElementById('offer')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-183">
              ELIMINAR MIS DEUDAS AHORA
            </Button>
          </div>
        </div>
      </RevealSection>

      {/* WHO THIS IS FOR / NOT FOR */}
      <RevealSection className="py-20 px-4 bg-gray-50 border-t border-gray-200" data-id="element-184">
        <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-8" data-id="element-185">
          {/* For */}
          <div className="bg-white p-8 rounded-2xl shadow-sm border-t-4 border-t-emerald-500" data-id="element-186">
            <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center gap-3" data-id="element-187">
              <CheckCircle2Icon className="w-8 h-8 text-emerald-500" data-id="element-188" />
              Para quién es esto
            </h3>
            <ul className="space-y-4" data-id="element-189">
              {['Mujeres y hombres de 50+ que están siendo acosados por deudas de hace más de 5 años.', 'Personas que reciben cartas de agencias de cobranza que no reconocen.', 'Quien quiera limpiar su historial crediticio de cuentas que ya deberían haber desaparecido.', 'Personas que viven en EE.UU. y quieren hacer valer sus derechos federales.'].map((item, i) => <li key={i} className="flex items-start gap-3 text-lg text-gray-700" data-id="element-190">
                  <CheckIcon className="w-6 h-6 text-emerald-500 flex-shrink-0 mt-0.5" data-id="element-191" />
                  <span data-id="element-192">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* Not For */}
          <div className="bg-white p-8 rounded-2xl shadow-sm border-t-4 border-t-red-500" data-id="element-193">
            <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center gap-3" data-id="element-194">
              <XCircleIcon className="w-8 h-8 text-red-500" data-id="element-195" />
              Para quién NO es
            </h3>
            <ul className="space-y-4" data-id="element-196">
              {['Personas con deudas muy recientes (menos de 2 años) que aún están en periodo de demanda activa.', 'Gente que busca "estafar" al sistema con deudas de manutención infantil o impuestos federales recientes.', 'Personas que no están dispuestas a enviar una carta formal por correo.'].map((item, i) => <li key={i} className="flex items-start gap-3 text-lg text-gray-700" data-id="element-197">
                  <XCircleIcon className="w-6 h-6 text-red-400 flex-shrink-0 mt-0.5" data-id="element-198" />
                  <span data-id="element-199">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </RevealSection>

      {/* HOW IT WORKS */}
      <RevealSection className="py-20 px-4 bg-white" data-id="element-200">
        <div className="max-w-4xl mx-auto" data-id="element-201">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-12 text-center" data-id="element-202">
            Cómo funciona en 3 simples pasos
          </h2>

          <div className="space-y-8 relative before:absolute before:inset-0 before:ml-6 before:-translate-x-px md:before:mx-auto md:before:translate-x-0 before:h-full before:w-0.5 before:bg-gradient-to-b before:from-transparent before:via-gray-200 before:to-transparent" data-id="element-203">
            <div className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active" data-id="element-204">
              <div className="flex items-center justify-center w-12 h-12 rounded-full border-4 border-white bg-blue-600 text-white font-bold text-xl shadow shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 z-10" data-id="element-205">
                1
              </div>
              <div className="w-[calc(100%-4rem)] md:w-[calc(50%-3rem)] p-6 rounded-2xl bg-gray-50 border border-gray-100 shadow-sm" data-id="element-206">
                <h3 className="font-bold text-2xl text-gray-900 mb-2" data-id="element-207">
                  Identifica
                </h3>
                <p className="text-lg text-gray-700" data-id="element-208">
                  Usa la guía para calcular si tu deuda ya prescribió según las
                  leyes de tu estado.
                </p>
              </div>
            </div>

            <div className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active" data-id="element-209">
              <div className="flex items-center justify-center w-12 h-12 rounded-full border-4 border-white bg-blue-600 text-white font-bold text-xl shadow shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 z-10" data-id="element-210">
                2
              </div>
              <div className="w-[calc(100%-4rem)] md:w-[calc(50%-3rem)] p-6 rounded-2xl bg-gray-50 border border-gray-100 shadow-sm" data-id="element-211">
                <h3 className="font-bold text-2xl text-gray-900 mb-2" data-id="element-212">
                  Notifica
                </h3>
                <p className="text-lg text-gray-700" data-id="element-213">
                  Copia nuestro modelo de carta y envíalo a la agencia de
                  cobranza.
                </p>
              </div>
            </div>

            <div className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active" data-id="element-214">
              <div className="flex items-center justify-center w-12 h-12 rounded-full border-4 border-white bg-emerald-500 text-white font-bold text-xl shadow shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 z-10" data-id="element-215">
                3
              </div>
              <div className="w-[calc(100%-4rem)] md:w-[calc(50%-3rem)] p-6 rounded-2xl bg-emerald-50 border border-emerald-100 shadow-sm" data-id="element-216">
                <h3 className="font-bold text-2xl text-emerald-900 mb-2" data-id="element-217">
                  Libérate
                </h3>
                <p className="text-lg text-emerald-800" data-id="element-218">
                  En cuanto reciban la carta, la ley les prohíbe contactarte de
                  nuevo. Paz recuperada.
                </p>
              </div>
            </div>
          </div>
        </div>
      </RevealSection>

      {/* PROOF */}
      <RevealSection className="py-16 px-4 bg-blue-50 border-y border-blue-100" data-id="element-219">
        <div className="max-w-4xl mx-auto text-center" data-id="element-220">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-blue-100 mb-6" data-id="element-221">
            <ShieldCheckIcon className="w-8 h-8 text-blue-600" data-id="element-222" />
          </div>
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-6" data-id="element-223">
            Resultados Comprobados
          </h2>
          <p className="text-xl md:text-2xl leading-relaxed text-gray-700 italic" data-id="element-224">
            "En solo 7 días después de aplicar este método, el 90% de los
            usuarios reporta un cese total de las llamadas telefónicas. No es
            magia, es simplemente que los cobradores no pierden el tiempo con
            personas que conocen sus derechos y saben cómo aplicarlos."
          </p>
        </div>
      </RevealSection>

      {/* FAQ */}
      <RevealSection className="py-20 px-4 bg-gray-50" data-id="element-225">
        <div className="max-w-3xl mx-auto" data-id="element-226">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-12 text-center" data-id="element-227">
            Preguntas Frecuentes
          </h2>
          <div className="space-y-4" data-id="element-228">
            <Accordion question="¿Es esto legal?" answer="Sí, está basado 100% en las leyes federales de protección al consumidor de EE.UU." data-id="element-229" />
            <Accordion question="¿Afectará mi crédito?" answer="Al contrario, aprenderás cómo disputar estas cuentas viejas para que salgan de tu reporte." data-id="element-230" />
            <Accordion question="¿Sirve para cualquier estado?" answer="Sí, cubrimos las variaciones legales de los 50 estados." data-id="element-231" />
            <Accordion question="¿Tengo que hablar con un juez?" answer="No, este método está diseñado para que resuelvas el problema desde tu casa." data-id="element-232" />
            <Accordion question="¿Recibiré algo por correo físico?" answer="No, es un producto digital de acceso inmediato tras el pago." data-id="element-233" />
          </div>
        </div>
      </RevealSection>

      {/* OFFER + CTA */}
      <RevealSection id="offer" className="py-24 px-4 bg-white" data-id="element-234">
        <div className="max-w-3xl mx-auto text-center" data-id="element-235">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-236">
            Recupera tu tranquilidad
          </h2>
          <p className="text-xl text-gray-700 mb-10" data-id="element-237">
            Pon fin a las noches de insomnio por solo una inversión única. Sin
            suscripciones, sin cargos ocultos, sin trucos.
          </p>

          <div className="bg-gray-50 rounded-3xl p-8 md:p-12 border-2 border-emerald-100 shadow-xl mb-10" data-id="element-238">
            <div className="text-gray-500 font-medium text-lg mb-2 uppercase tracking-wider" data-id="element-239">
              Inversión Única
            </div>
            <div className="mb-4" data-id="element-240">
              <div className="text-2xl text-gray-400 line-through font-semibold mb-2" data-id="element-241">
                $21.30 USD
              </div>
              <div className="inline-block bg-red-500 text-white px-4 py-1 rounded-full text-sm font-bold uppercase tracking-wide mb-4" data-id="element-242">
                Ahorra 70%
              </div>
            </div>
            <div className="text-6xl font-extrabold text-gray-900 mb-8" data-id="element-243">
              $6.39{' '}
              <span className="text-2xl text-gray-500 font-medium" data-id="element-244">USD</span>
            </div>

            <Button className="w-full md:w-auto md:px-12 py-6 text-2xl" onClick={handleAddToCart} data-id="element-245">
              ELIMINAR MIS DEUDAS AHORA
            </Button>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-6 mt-8 text-gray-600 font-medium" data-id="element-246">
              <span className="flex items-center gap-2" data-id="element-247">
                <LockIcon className="w-5 h-5 text-emerald-600" data-id="element-248" />
                Pago 100% seguro
              </span>
              <span className="flex items-center gap-2" data-id="element-249">
                <CheckCircle2Icon className="w-5 h-5 text-emerald-600" data-id="element-250" />
                Acceso instantáneo a la guía tras completar tu pedido
              </span>
            </div>
          </div>

          <div className="flex items-center justify-center gap-2 text-gray-500 text-sm" data-id="element-251">
            <ShieldIcon className="w-4 h-4" data-id="element-252" />
            <span data-id="element-253">Garantía de satisfacción respaldada por la ley FDCPA</span>
          </div>
        </div>
      </RevealSection>

      <Footer data-id="element-254" />
    </main>;
}